import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../PiecesList/types';
import IconsBarCanvas from '../IconsBarCanvas';
import ShowFurnitureButton from '../Configurator/ShowFurnitureButton';
import { useMedia } from 'use-media';
import styled from 'styled-components/macro';
import { shelvesSelectionAction } from '../Configurator/actions/selection';
import TabNames from '../Header/TabNames';
import {
  makeSelectPreview,
  makeSelectSelectedIdCabinet,
} from '../Configurator/selectors/furniture';
import { makeSelectActiveTab } from '../Header/selectors';
import { makeSelectShelvesLevelSelected } from '../Configurator/selectors/selection';
import {
  makeSelectActivePanel,
  makeSelectDisplaySchemaDimension,
} from '../Configurator/selectors/general';
import { ActivePanel } from '../Configurator/constants/general';
import ModeBar from '../ModeBar';
import { makeSelectConfiguratorMode } from '../ModeBar/selectors';
import { ConfiguratorMode } from '../ModeBar/reducer';

interface StateProps {
  indexCabinet: string | null;
  activeTab: TabNames;
  selectedShelfLevel: number[];
  activePanel: ActivePanel | undefined;
  preview: boolean;
  mode: ConfiguratorMode;
  displaySchemaDimension: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  indexCabinet: makeSelectSelectedIdCabinet(),
  activeTab: makeSelectActiveTab(),
  selectedShelfLevel: makeSelectShelvesLevelSelected(),
  activePanel: makeSelectActivePanel(),
  preview: makeSelectPreview(),
  mode: makeSelectConfiguratorMode(),
  displaySchemaDimension: makeSelectDisplaySchemaDimension(),
});

const IconsCanvas = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    indexCabinet,
    activeTab,
    selectedShelfLevel,
    activePanel,
    preview,
    mode,
    displaySchemaDimension,
  } = useSelector(stateSelector);

  const isMobile = useMedia({ maxWidth: 1023 });

  if (isMobile)
    return (
      <div className="absolute bottom-0 z-10 w-full flex justify-center">
        {indexCabinet !== null &&
          !preview &&
          activeTab === 'shelves' &&
          selectedShelfLevel &&
          selectedShelfLevel.length > 0 && (
            <div>
              <button
                onClick={() => {
                  dispatch(shelvesSelectionAction([]));
                }}
                className="border border-gray-400 py-1 px-3 text-gray-800 bg-white"
              >
                {t('Select all compartments')}
              </button>
            </div>
          )}
      </div>
    );

  return (
    <>
      <div className="absolute top-0 left-0 mt-1 z-20">
        <ShowFurnitureButton />
      </div>
      {indexCabinet !== null &&
        mode === ConfiguratorMode.selector &&
        !preview &&
        activeTab === 'shelves' &&
        activePanel !== ActivePanel.crossPieces &&
        selectedShelfLevel &&
        selectedShelfLevel.length > 0 && (
          <StyledAllShelves>
            <button
              onClick={() => {
                dispatch(shelvesSelectionAction([]));
              }}
              className="border border-gray-400 py-1 px-3 text-gray-800 bg-white"
            >
              {t('Select all compartments')}
            </button>
          </StyledAllShelves>
        )}
      {/*      {preview && (
        <StyledAllShelves>
          <div className="text-2xl  italic py-0 text-gray-700 w-full flex justify-center items-center mx-2">
            <div className="">{t('Preview')}</div>
          </div>
        </StyledAllShelves>
      )}*/}

      <IconsBarCanvas hideDimensionInfo={indexCabinet === null} />
      {indexCabinet && !displaySchemaDimension && <ModeBar />}
    </>
  );
};

export default IconsCanvas;

const StyledAllShelves = styled.div`
  position: absolute;
  top: 0;
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
`;
